// export * from "./Auth";
import React from "react";

/**
 * Importing and re-exporting modules for easier access.
 * Exports all components from "Admin" and "User" modules.
 * @module ExportedComponents
 */

export * from "./Admin";
export * from "./User";
export * from "./Instructor";
/**
 * Lazy-loaded component for handling 404 (Not Found) pages.
 * @constant {React.Component} NotFound
 * @see {@link module:ExportedComponents}
 */
export const NotFound = React.lazy(() => import("./NotFound"));

